import { i18n } from '@lingui/core';
import { AgencyTemplateDTO, CreateAgencyTemplateDto } from '../Types/MessageT';
import { BookingState, RecommendationMailType } from '../Types/RecommendationT';
import { StringUtils } from '../Utils/utils';
import { ajaxActions } from './AjaxActions';
import { ConstantS } from './ConstantS';
import { EventS } from './EventS';
import { MixpanelS } from './MixpanelS';
import { ToastS } from './ToastS';

const BASE_URL = `${process.env.REACT_APP_MESSAGE_SERVICE_URL}/agency/templates`;

const create = async (name: string, body?: CreateAgencyTemplateDto): Promise<AgencyTemplateDTO | null> => {
  const res = await ajaxActions.post(`${BASE_URL}?name=${name}`, body);
  if (res.status === 201) {
    ToastS.info('template-created', `Vorlage ${name} erstellt`);
    MixpanelS.track(ConstantS.TrackingEvents.AgencyTemplateCreated);
    return res.json();
  }
  ToastS.generalError();
  return null;
};

const copy = async (originId: string): Promise<AgencyTemplateDTO | null> => {
  const res = await ajaxActions.post(`${BASE_URL}/copy/${originId}`);
  if (res.status === 201) {
    ToastS.info('template-created', 'Kopie erstellt');
    return res.json();
  }
  ToastS.generalError();
  return null;
};

const edit = async (id: string, patch: Partial<AgencyTemplateDTO>): Promise<AgencyTemplateDTO | null> => {
  const res = await ajaxActions.patch(`${BASE_URL}/${id}`, patch);
  if (res.ok) {
    return res.json();
  }
  ToastS.generalError();
  return null;
};

const getAll = async (): Promise<AgencyTemplateDTO[]> => {
  const res = await ajaxActions.get(`${BASE_URL}/all`);
  if (res.ok) {
    return res.json();
  }
  return [];
};

const getAllNames = async (): Promise<string[]> => {
  const res = await ajaxActions.get(`${BASE_URL}/all-names`);
  if (res.ok) {
    return res.json();
  }
  return [];
};

const getById = async (id: string): Promise<AgencyTemplateDTO | null> => {
  const res = await ajaxActions.get(`${BASE_URL}/${id}`);
  if (res.ok) {
    return res.json();
  }
  return null;
};

const remove = async (id: string): Promise<boolean> => {
  const res = await ajaxActions.del(`${BASE_URL}/${id}`);
  if (res.ok) {
    ToastS.info('template-removed', 'Vorlage gelöscht');
    MixpanelS.track(ConstantS.TrackingEvents.AgencyTemplateDeleted);
    return true;
  }
  ToastS.generalError();
  return false;
};

const resolveDefaultSubject = (
  type: RecommendationMailType,
  recommendationDates: Date[],
  profileAlias: string | undefined,
  bookingState?: BookingState,
) => {
  const datesString = StringUtils.concatStrings(recommendationDates.map(EventS.formatEventDate));
  if (type === 'REGULAR') {
    return `Nachricht von ${profileAlias}`;
  }
  if (type === 'CHECK_AVAILABILITY') {
    return `Verfügbar am ${datesString}`;
  }
  if (type === 'CANCELLATION') {
    return `Vermittlung entfernt für Event am ${datesString}`;
  }
  if (type === 'CHANGE_STATUS') {
    return `[${i18n._(
      `recommendation.bookingState.${bookingState?.toLowerCase()}`,
    )}] Vermittlung für den ${datesString}`;
  }
  return `Event-Infos für den ${datesString}`;
};

// eslint-disable-next-line import/prefer-default-export
export const AgencyTemplateS = {
  create,
  copy,
  edit,
  getAll,
  getById,
  remove,
  getAllNames,
  resolveDefaultSubject,
};
